import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function ProgramsComponent() {

  const programs = [
    {
      img: "https://blog.organicbazar.net/wp-content/uploads/2022/03/plants-sunlight-min.jpg",
      title: "Climate Education and Environmental Stewardship",
      desc: "A structured climate literacy and capacity-building program aimed at strengthening environmental awareness, promoting sustainable resource management, and advancing community-based climate adaptation practices."
    },
    {
      img: "https://landproperty.ng/wp-content/uploads/2025/07/new.jpeg",
      title: "Climate-Smart Agriculture and Landscape Restoration",
      desc: "An integrated program supporting the adoption of climate-smart agricultural practices, agroforestry systems, soil health improvement, reforestation, and biodiversity conservation to enhance ecosystem resilience and food security."
    },
    {
      img: "https://farmingfarmersfarms.com/wp-content/uploads/2026/04/young-farmers.jpg",
      title: "Youth and Women Economic Empowerment Initiative",
      desc: "A targeted empowerment framework focused on skills development, enterprise support, access to productive resources, and inclusive livelihood opportunities for women and youth to strengthen climate-resilient and sustainable economic participation."
    }
  ];



  const metrics = [
    { value: 1000, label: "Hectares of land under sustainable restoration and climate-smart management", suffix: "+" },
    { value: 45000, label: "tCO₂e Greenhouse gas emissions avoided or mitigated through climate-smart practices", suffix: "+" },
    { value: 1500, label: "Farmers, women, and youth equipped with skills in climate-smart agriculture and sustainability", suffix: "+" },
    { value: 1000, label: "Green jobs and livelihood opportunities created across local value chains", suffix: "+" }
  ];

  const [displayValues, setDisplayValues] = useState(metrics.map(() => 0));

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 120,
      easing: "ease-out-cubic",
    });
  }, []);

  useEffect(() => {
    const start = setTimeout(() => {
      metrics.forEach((metric, index) => {
        let count = 0;

        const interval = setInterval(() => {
          count++;

          const random = Math.floor(Math.random() * metric.value);

          setDisplayValues((prev) => {
            const updated = [...prev];
            updated[index] = random;
            return updated;
          });

          if (count > 15) {
            clearInterval(interval);

            setDisplayValues((prev) => {
              const updated = [...prev];
              updated[index] = metric.value;
              return updated;
            });
          }
        }, 60);
      });
    }, 300);

    return () => clearTimeout(start);
  }, []);

  return (
    <section className="relative bg-[#F7F4EE] py-14 lg:py-24 px-6 md:px-16 lg:px-28 overflow-hidden">

      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div data-aos="fade-up" className="mb-10 lg:mb-24">
           <p className="text-xs tracking-[0.35em] text-green-500 uppercase">
            Programs & Initiatives
          </p>

          <h2
            data-aos="fade-up"
            data-aos-delay="100"
            className="mt-5 text-3xl md:text-6xl font-semibold text-[#1E1B16]"
          >
            Regenerative Impact System
          </h2>
        </div>

        {/* PROGRAM CARDS */}
        <div className="grid md:grid-cols-3 gap-12">

          {programs.map((p, i) => (
            <div
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 150}
              className="group"
            >

              <div className="overflow-hidden rounded-2xl mb-6">
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full h-[260px] object-cover group-hover:scale-105 transition duration-700"
                />
              </div>

              <h3 className="text-xl font-medium text-center text-[#1E1B16]">
                {p.title}
              </h3>

              <p className="mt-3 text-sm text-[#5C5548] text-center leading-relaxed">
                {p.desc}
              </p>

            </div>
          ))}

        </div>

     {/* IMPACT DASHBOARD */}

      </div>
    </section>
  );
}